export const getInitials = (name: string, surname?: string | null): string => {
	const parts = [name, surname]
		.filter((value) => Boolean(value?.trim()))
		.join(' ')
		.trim()
		.split(/\s+/)
		.slice(0, 2);

	return parts
		.map((part) => part.at(0) ?? '')
		.join('')
		.toUpperCase();
};
